import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.transaction.search.sortFields,
	columnFields: constants.transaction.search.columnFields,
	standardFilterFields: constants.transaction.search.standardFilterFields,
	dateFilterFields: constants.transaction.search.dateFilterFields,
	stageStatusFilterFields: constants.transaction.search.stageStatusFilterFields,
	booleanFilterFields: [] as const,
});
